import React from 'react';
import { Datagrid, List, TextField, NumberField } from 'react-admin';
import { CustomDateField } from '../../../../commonComponents/DateField';
import CustomReportListActions from '../../../../commonComponents/ListActions/CustomReportListActions';
import PersonalityQuizReportsFilter from './PersonalityQuizReportsFilter';

const HtmlField = ({ record, source, maxLength = 70 }) => {
  const htmlContent = record[source] || '';

  const plainText = htmlContent.replace(/<[^>]*>/g, ' ');
  const truncatedText = plainText.length > maxLength ? `${plainText.substring(0, maxLength)}...` : plainText;

  return (
    <div title={plainText} style={{ cursor: 'help' }}>
      {truncatedText}
    </div>
  );
};

const PersonalityQuizReportsList = (props) => (
  <List
    title="Personality quiz reports"
    actions={<CustomReportListActions />}
    filters={<PersonalityQuizReportsFilter />}
    bulkActionButtons={false}
    sort={{ field: 'id', order: 'DESC' }}
    {...props}
  >
    <Datagrid>
      <TextField label="Game ID" source="id" />
      <TextField label="User ID" source="user_id" />
      <TextField label="Quiz name" source="pack_name" />
      <HtmlField label="Result" source="result" />
      <NumberField label="Credits" source="credits" />
      <CustomDateField label="Date" source="created_at" />
    </Datagrid>
  </List>
);

export default PersonalityQuizReportsList;
